import React from 'react';
import * as S from './style';

const FiveInfo = () => {
  return (
    <S.Container>
      <S.Title>
        <span role='img' aria-label='emoji'>
          👇
        </span>
        마스크 5부제에 대해서 알고 계신가요?{' '}
        <span role='img' aria-label='emoji'>
          👇
        </span>
      </S.Title>
      <a
        href='https://namu.wiki/w/%EB%A7%88%EC%8A%A4%ED%81%AC%205%EB%B6%80%EC%A0%9C'
        target='__blank__'
      >
        <S.Img src='./img/mask-five.png' alt='마스크 5부제' />
      </a>
      <S.Cf>
        전국 각지에서 코로나와 맞서 싸우시는 분들
        <br />
        모두 응원합니다!
        <br />
        <br />
        <a href='mailto:inwalter99@gmail.com'>버그 리포트/제안은 이곳에!</a>
        <br />
        <br />
        powered by inthewalter
      </S.Cf>
    </S.Container>
  );
};

export default FiveInfo;
